import { render, staticRenderFns } from "./ImportFeed.vue?vue&type=template&id=0642d2af&scoped=true&"
import script from "./ImportFeed.vue?vue&type=script&lang=js&"
export * from "./ImportFeed.vue?vue&type=script&lang=js&"
import style0 from "./ImportFeed.vue?vue&type=style&index=0&id=0642d2af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642d2af",
  null
  
)

export default component.exports